import { DashDonationType } from '@nkr/enums/index';
import { ICenterBase } from '@nkr/models/index';
import { hasForeignResidence } from './utils/international-eligibility';

let cachedEnabledCenterIds: readonly number[] | null = null;

export function seedAdvReimburseEnabledCenters(centers: ICenterBase[] | null | undefined): void {
    if (!Array.isArray(centers)) {
        return;
    }
    cachedEnabledCenterIds = centers
        .filter(c => c != null && c.isAdvReimburseEnabled === true)
        .map(c => Number(c.id))
        .filter(id => !isNaN(id) && id > 0);
}

export function getAdvReimburseEnabledCenterIds(): readonly number[] {
    return cachedEnabledCenterIds ?? [];
}

export function isAdvReimburseEnabledCentersLoaded(): boolean {
    return cachedEnabledCenterIds != null;
}

export function isAdvReimburseEnabledForCenter(centerId: number | null | undefined): boolean {
    if (centerId == null || Number(centerId) <= 0) {
        return false;
    }
    const ids = getAdvReimburseEnabledCenterIds();
    return ids.indexOf(Number(centerId)) >= 0;
}

export function isAdvReimburseEligibleOrgan(donationType: number | null | undefined): boolean {
    const organ = Number(donationType);
    return organ === DashDonationType.Kidney || organ === DashDonationType.Liver;
}

export function canShowAdvReimburseAction(
    centerId: number | null | undefined,
    donationType: number | null | undefined,
    countryOfResidenceId?: number | null,
    isDcnParticipant?: boolean | null
): boolean {
    const isArEnabled = isAdvReimburseEnabledForCenter(centerId);
    const isDcn = isDcnParticipant === true;
    const organ = Number(donationType);
    const isIntlIntake = hasForeignResidence(countryOfResidenceId);

    if (isIntlIntake) {
        if (organ !== DashDonationType.Kidney && organ !== DashDonationType.Liver) {
            return false;
        }
        return isDcn;
    }

    if (!isArEnabled) {
        return false;
    }

    return isAdvReimburseEligibleOrgan(donationType);
}
